import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import AbstractConfig from "../../../core/config/AbstractConfig";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecisionsConfig extends AbstractConfig {
    constructor() {
        super();

        this._memoizedKeyDecisionDefinitions = null;
    }

    /**
     * @returns {Array<KeyDecisionDefinition>}
     */
    get keyDecisionDefinitions() {
        if (this._memoizedKeyDecisionDefinitions) {
            return this._memoizedKeyDecisionDefinitions;
        }

        this._memoizedKeyDecisionDefinitions = this.getValue('keyDecisions')
            .map(kd => new KeyDecisionDefinition(kd.id, kd.chapter, kd.contentId, kd.backgroundImageId));

        return this._memoizedKeyDecisionDefinitions;
    }

    get keyDecisionContentIds() {
        return this.keyDecisionDefinitions.map(kd => kd.contentId);
    }

    getKeyDecisionsByChapter(chapter) {
        return this.keyDecisionDefinitions.filter(kd => kd.chapter === chapter);
    }

    /**
     * @param {Content} content 
     * @returns {KeyDecisionDefinition}
     */
    getKeyDecisionDefinitionByContent(content) {
        return this.getKeyDecisionDefinitionByContentId(content.getContentID());
    }

    /**
     * @param {string} contentId
     * @returns {KeyDecisionDefinition}
     */
    getKeyDecisionDefinitionByContentId(contentId) {
        return this.keyDecisionDefinitions.find(kd => kd.contentId === contentId);
    }

    /**
     * @param {Content} content 
     * @return {boolean}
     */
    contentIsKeyDecision(content) {
        const contentId = content.getContentID();
        if (!contentId) {
            // Key decision content must have a content id to be linked to additional key decision information.
            return false;
        }

        return this.keyDecisionContentIds.indexOf(contentId) > -1;
    }
}
